<template>
    <router-link :to="{ name: 'product_info', params: { id: data.id } }">
        <div class="card shadow-sm h-100">
        <!-- <a :href="`${data.link}`"> -->
            <!-- <div class="position-relative"> -->
                <!-- <a href="" class="d-block position-absolute w-100 h-100 top-0 start-0" aria-label="Course link"></a> -->
                    <!-- <div class="position-absolute mt-1 w-100 px-2"> -->
                        <!-- <span v-if="data.price < 10" class="badge bg-success me-1">Best Seller</span> -->
                        <!-- <a href="#" class="btn btn-sm rounded-circle float-end end-0" data-bs-toggle="tooltip" data-bs-placement="left" aria-label="Save to Favorites" data-bs-original-title="Save to Favorites">
                            <i class="fas fa-share"></i>
                        </a> -->
                        <!-- <a class="btn btn-sm rounded-circle float-end end-0" data-bs-toggle="tooltip" data-bs-placement="left" aria-label="Save to Favorites" data-bs-original-title="Save to Favorites">
                            <i class="far fa-heart"></i>
                        </a> -->
                    <!-- </div> -->
                <!-- <img :src="data.image" class="card-img-top" alt="Image"> -->
                <div class="card-img-top" :style="`background-image: url(${data.product_images.length ? data.product_images[0].image : data.image});`"></div>
            <!-- </div> -->
            <div class="card-body pb-3">
                <h3 class="h6 mb-2 text-site">
                    {{data.translate.length ? data.translate[0].name : data.name}}
                </h3>
                <!-- <router-link :to="{ name: 'product_info', params: { id: data.id } }"> -->
                <!-- </router-link> -->
                <p class="fs-7 mb-2">{{data.translate.length && data.translate[0].description ? data.translate[0].description.substring(0, 100) : data.info}}</p>
            </div>
            <div class="card-footer fs-sm text-muted bg-white border-top-0">
                <p v-if="data.size" class="fs-7 mb-2 text-secondary">{{ lang?.size }}:
                    <span v-for="(sitem, sindex) in data.size" :key="sindex" class="py-1 px-2 me-1 bg-light text-dark">
                        {{ sitem }}
                    </span>
                </p>
                <p class="fs-7 fw-semibold">{{ lang?.price }}: {{ $filters.formatCurrency(data.price) }}</p>
            </div>
            <!-- <div class="card-footer fs-sm text-muted">
                <div class="d-flex align-items-center me-40">
                    <i class="fas fa-list fs-xl me-1"></i>
                </div>
                <div class="d-flex align-items-center">
                    <i class="fas fa-cogs fs-xl me-1"></i>
                </div>
            </div> -->
        <!-- </a> -->
        </div>
    </router-link>
</template>


<script>
export default {
    name: "ProductC",
    props:{
        data: {
            type: Object,
            default: () => {}
        },
        lang: {
            type: Object,
            default: () => {}
        },
    },
    setup() {
        return {
        };
    },
}
</script>

<style lang="scss" scoped>
// .card-footer{
//     background-color: #fff !important;
// }
.card{
    transition-duration: .1s;
    transition-timing-function: linear;
    border-radius: 20px;
}
.card-footer{
    border-radius: 20px;
}
.card:hover{
    // box-shadow: 0px 0px 15px #cdcdcd !important;
    box-shadow: 0px 0px 10px #0f0e0e !important;
    transform: scale(0.98, 0.98);
    border-radius: 20px;
}
.card-img-top{
    width: 100%;
    height: 240px;
    background-size: cover;
    // background-size: contain;
    background-repeat: no-repeat;
    background-position: top;
    background-color: #efefef;
    border-radius: 20px 20px 0 0;
}
</style>
